import lscache from "lscache";

import {PHONE_VERIFICATION_CODE_SENT_LS_KEY, PHONE_VERIFICATION_TIMER_START_LS_KEY} from "../../constants/phone_verification_constants";

export const clearPhoneVerificationTimerLS = () => {
    lscache.remove(PHONE_VERIFICATION_TIMER_START_LS_KEY);
    lscache.remove(PHONE_VERIFICATION_CODE_SENT_LS_KEY);
};
import lscache from "lscache";

import {PHONE_VERIFICATION_CODE_SENT_LS_KEY, PHONE_VERIFICATION_TIMER_START_LS_KEY} from "../../constants/phone_verification_constants";

export const clearPhoneVerificationTimerLS = () => {
    lscache.remove(PHONE_VERIFICATION_TIMER_START_LS_KEY);
    lscache.remove(PHONE_VERIFICATION_CODE_SENT_LS_KEY);
};
